import { useRouter } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import {
	ANALYTICS_EVENTS,
	buildPageViewProperties,
	useAnalytics,
} from "@/lib/analytics";

export function usePageViewAnalytics(locale: string) {
	const router = useRouter();
	const { capture, canCapture } = useAnalytics();
	const lastPage = useRef<string | null>(null);
	const pathname = router.state.location.pathname;

	useEffect(() => {
		if (!canCapture) {
			lastPage.current = null;
			return;
		}
		const page = `${locale}:${pathname}`;
		if (lastPage.current === page) return;
		lastPage.current = page;
		capture(
			ANALYTICS_EVENTS.pageView,
			buildPageViewProperties({ pathname, locale }),
		);
	}, [capture, canCapture, pathname, locale]);
}
